// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"MT-z","inlineTitle":"NT-z","sponsoredAdsWrapper":"OT-z","marketplaceRecosWrapper":"PT-z"};